import DownloadAppComponent from "./DownloadAppComponent";

const DownloadAppSection = ({ id, showArrow = true }: any) => {
  return <DownloadAppComponent id={id} showArrow={showArrow} />;
};

export default DownloadAppSection;
